





























































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import moment from 'moment';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import InventoryAdvancePaymentStatusDisplay from '@/components/requisition-common/InventoryAdvancePaymentStatusDisplay.vue';
import {
  InventoryAdvancePaymentStatus,
  IInventoryAdvancePayment,
  InventoryAdvancePaymentStatusEnum
} from '@/models';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default Vue.extend({
  components: { ErrorAlert, InventoryAdvancePaymentStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous Status',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current Status',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    inventoryAdvancePaymentActivities: get<Transition[]>(
      'inventoryAdvancePayment/getInventoryAdvancePaymentActivities'
    )
  },

  methods: {
    moment,

    ...mapActions({
      fetchInventoryAdvancePaymentActivities:
        'inventoryAdvancePayment/fetchInventoryAdvancePaymentActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(inventoryAdvancePayment: IInventoryAdvancePayment) {
      this.clearAllErrors();

      this.dialog = true;
      this.loading = true;

      this.fetchInventoryAdvancePaymentActivities(inventoryAdvancePayment.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    },

    getInventoryAdvancePaymentStatusFromState(
      state: InventoryAdvancePaymentStatusEnum
    ) {
      return InventoryAdvancePaymentStatus.getStateList().find(
        status => state === status.value
      );
    }
  }
});
